import Image from 'next/image';
import Badge from '@/components/pages/badge';
import type { Attorney } from '@jlg-website/database/types';
import { ArrowRight, Mark } from '@/components/pages/icons';
import Link from 'next/link';

export function TeamCarouselItem({
  member,
  showLocation = false,
  showLink,
}: {
  member: Attorney;
  showLocation?: boolean;
  showLink?: boolean;
}) {
  return (
    <div className="relative rounded-2xl overflow-hidden shrink-0 cursor-pointer group w-75 h-95">
      <Image
        src={member.picture || ''}
        alt={member.name}
        width={318}
        height={413}
        className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105 aspect-77/100"
        sizes="300px"
      />

      <div className="group-hover:opacity-0 absolute bottom-0 left-0 right-0 h-[141px] rounded-b-2xl bg-black/30 backdrop-blur-[11.5px] [-webkit-mask-image:linear-gradient(to_bottom,transparent_0%,rgba(0,0,0,0.46)_36.5%,black_63%)] mask-[linear-gradient(to_bottom,transparent_0%,rgba(0,0,0,0.46)_36.5%,black_63%)] transition-opacity duration-300" />

      {showLocation && (
        <div className="absolute top-3 left-3">
          <Badge icon={<Mark className="w-3.5 h-3.5" />} label={'Cleveland, OH'} />
        </div>
      )}

      <div className="absolute bottom-0 left-0 right-0 p-5 flex items-end justify-between">
        <div>
          <h3 className="text-white font-semibold leading-[1.2] text-[32px] font-serif tracking-[-0.64px]">
            {member.name}
          </h3>
          <p className="text-white text-base font-bold">{member.content.en.data.degree}</p>
        </div>

        {showLink && (
          <Link
            href="#"
            className="cursor-pointer shrink-0 w-11 h-11 rounded-full bg-brand-button hover:brightness-90 flex items-center justify-center text-white transition-all duration-200 shadow-lg"
          >
            <ArrowRight className="w-5 h-5" />
          </Link>
        )}
      </div>
    </div>
  );
}

export default TeamCarouselItem;
